import { useMemo } from 'react';
import { Tabs } from '@getsynapse/design-system';
import intl from 'react-intl-universal';

import DetailsPage from 'Molecules/DetailsPage/DetailsPage';
import BundleOverview from '../BundleOverview';
import BuildBundle from '../BuildBundle';
import DeleteTaskBundle from '../../../DeleteTaskBundle/DeleteTaskBundle';

import { useTaskBundleDraft } from '../../providers/TaskBundleProvider/TaskBundleProvider';
import { TaskBundleMode } from '../../types';
import { isEditingMode } from '../../helpers';

type TaskBundleTabsProps = {
  activeTab: number;
  onTabChange: (index: number) => void;
  mode: TaskBundleMode;
};

const TaskBundleTabs: React.FC<TaskBundleTabsProps> = ({
  activeTab,
  onTabChange,
  mode,
}) => {
  const { selectors } = useTaskBundleDraft();

  const isEditing = isEditingMode(mode);

  const tabData = useMemo(
    () => [
      {
        label: intl.get('SETTINGS_PAGE.TASK_BUNDLE_PAGE.BUNDLE_OVERVIEW_TAB'),
        content: <BundleOverview isEditing={isEditing} />,
      },
      {
        label: intl.get('SETTINGS_PAGE.TASK_BUNDLE_PAGE.BUNDLE_BUILD_TAB'),
        content: <BuildBundle isEditing={isEditing} />,
      },
    ],
    [isEditing]
  );

  return (
    <DetailsPage
      topBar={
        isEditing && (
          <DeleteTaskBundle
            data={{
              id: selectors.draft.bundle.id,
              name: selectors.draft.bundle.name,
              description: selectors.draft.bundle.description,
            }}
          />
        )
      }
      bodyClassName='overflow-y-visible'
      content={
        <Tabs
          data={tabData}
          index={activeTab}
          onChange={(index: number) => {
            onTabChange(index);
          }}
        />
      }
    />
  );
};

export default TaskBundleTabs;
